export let isMobile = window.matchMedia(`(max-width: 480px)`);
export let isEmbedded = window.top != window;

export let mediaValues = {
  get paddingTop() { return isMobile.matches ? window.innerHeight * .2 : 0 },
  get paddingSchool() { return isMobile.matches ? window.innerHeight * .3 : 0 },
  get dotSize() { return isMobile.matches ? [14, 14] : [10, 10] },
}